import React, { useState } from 'react';
import queryString from 'query-string';
import LeadsView from './Leads.view';
import LeadsComplete from './Leads.complete';
import stepViews from './LeadsSteps';

export default function Leads(props) {
  const { ref, requestId } = queryString.parse(props.location.search);
  const { match: { params: { inviteId } = {} } = {} } = props;
  const key = { ref, requestId, inviteId };
  const [progress, setProgress] = useState({
    step: 0, authenticated: false, error: false, loading: false,
  });
  const [validations, setValidations] = useState({});
  const [formData, setFormData] = useState({
    verify: '',
    ssn: '',
    bankruptcyCurrent: '',
    bankruptcyFuture: '',
    birthday: '',
    employerAddress: '',
    employerCity: '',
    employerPostalCode: '',
    employerProvince: '',
    industryCode: '',
    jobCode: '',
    maritalStatus: '',
    payrollType: '',
    personalTitle: '',
    primaryAccountKey: '',
    workPhone: '',
    workPhoneExt: '',
  });

  const onFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const onNext = async () => {
    setProgress({
      ...progress,
      loading: true,
    });
    const { action } = stepViews[progress.step];
    const result = await action(key, progress, formData);
    if (result.error) {
      setProgress({
        ...progress,
        error: result.error,
      });
      return;
    }
    if (!result.authenticated) {
      setProgress({
        ...progress,
        error: 'Unable to authenticate.',
      });
      return;
    }
    if (result.invalid) {
      setProgress({
        ...progress,
        error: 'The application can not be completed at this time.',
      });
      return;
    }
    setProgress({
      ...progress,
      ...result,
      step: progress.step + 1,
      error: false,
    });
  };

  const onBack = async () => {
    setProgress({
      ...progress,
      step: Math.max(0, progress.step - 1),
      error: false,
    });
  };

  if (progress.step >= stepViews.length) {
    return (
      <LeadsComplete
        requestKey={key}
        formData={formData}
      />
    );
  }

  const { component: StepView, validationConfig } = stepViews[progress.step];
  const activeButtonText = progress.step >= (stepViews.length - 1) ? 'Finish' : 'Next';
  return (
    <LeadsView
      formData={formData}
      validationConfig={validationConfig}
      onNext={onNext}
      activeButtonText={activeButtonText}
      currentStep={progress.step}
      totalStepCount={stepViews.length - 1}
      onBack={onBack}
      onFormValidated={setValidations}
      error={progress.error}
      loading={progress.loading}
    >
      <StepView
        application={progress.data}
        formData={formData}
        validations={validations}
        onChange={onFieldChange}
      />
    </LeadsView>
  );
}
